import { useMemo } from 'react';

import { Text } from '../TextComponent';
import { Box } from '../lib/components';
import { GradientTextProps } from './types';

export const GradientText = ({
    text,
    colors,
    positions,
    variant = 'titleMedium',
    fontSize,
    lineHeight,
    fontWeight,
    letterSpacing,
}: GradientTextProps) => {
    const gradientBackground = useMemo(() => {
        const stops = positions.map((pos, i) => {
            const pct = pos * 100;
            return `${colors[i]} ${pct}%`;
        });

        return `linear-gradient(to right, ${stops.join(', ')})`;
    }, [colors, positions]);

    const gradientTextStyle = useMemo(
        () => ({
            backgroundImage: gradientBackground,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            WebkitTextFillColor: 'transparent',
            whiteSpace: 'nowrap',
        }),
        [gradientBackground]
    );

    return (
        <Box alignSelf="flex-start">
            <Text
                variant={variant}
                numberOfLines={1}
                style={gradientTextStyle}
                fontSize={fontSize}
                lineHeight={lineHeight}
                fontWeight={fontWeight}
                letterSpacing={letterSpacing}
            >
                {text}
            </Text>
        </Box>
    );
};
